export interface Experience {
  slug: string;
  title: string;
  description: string;
  tags: string[];
  repo: string;
  thumbnail: string;
  status: "live" | "coming-soon";
}

export const experiences: Experience[] = [
  {
    slug: "poker-practice",
    title: "Poker Practice",
    description: "Play, see, repeat. Practice poker with visible draws, live odds, and a coach beside your hand.",
    tags: ["Poker", "Three.js", "Probability", "Interactive"],
    repo: "https://github.com/ErikkJs/goatsquadstudios",
    thumbnail: "/experience_thumbnails/poker-practice.png",
    status: "live",
  },
  {
    slug: "scale-of-the-universe",
    title: "Scale of the Universe",
    description: "Journey from the Moon to the Cosmic Microwave Background",
    tags: ["Three.js", "WebGL", "Space", "Education"],
    repo: "https://github.com/ErikkJs/goatsquadstudios",
    thumbnail: "/experience_thumbnails/scale_of_the_universe.png",
    status: "live",
  },
  {
    slug: "sorting-algorithms",
    title: "Sorting Algorithms",
    description: "Interactive 3D visualizations of sorting algorithms",
    tags: ["Three.js", "Algorithms", "Education", "Interactive"],
    repo: "https://github.com/ErikkJs/goatsquadstudios",
    thumbnail: "/experience_thumbnails/sorting_algorithms.png",
    status: "live",
  },
  {
    slug: "neural-network-flow",
    title: "Neural Network Flow",
    description: "Visualize activations flowing through MobileNetV2 in real-time",
    tags: ["Three.js", "ONNX", "Machine Learning", "Interactive"],
    repo: "https://github.com/ErikkJs/goatsquadstudios",
    thumbnail: "/blog_images/neural-network-flow/neural_network_thumbnail.png",
    status: "live",
  },
  {
    slug: "gravitational-lensing",
    title: "Gravitational Lensing",
    description: "Drag a black hole across a starfield and watch spacetime bend the light",
    tags: ["Three.js", "WebGL", "Physics", "GLSL", "Education"],
    repo: "https://github.com/ErikkJs/goatsquadstudios",
    thumbnail: "/experience_thumbnails/gravitational-lensing.png",
    status: "live",
  },
  {
    slug: "humanity-writing-itself",
    title: "Humanity Writing Itself",
    description: "Real-time Wikipedia edits as particles bursting from their linguistic origin on a globe. Watch who's actually doing the writing.",
    tags: ["WebSocket", "Real-time", "Globe", "Data", "Interactive"],
    repo: "https://github.com/ErikkJs/goatsquadstudios",
    thumbnail: "/experience_thumbnails/humanity-writing-itself.png",
    status: "live",
  },
  {
    // COPY REVIEW: title/description/tags are client-facing marketing copy and
    // need Erik's sign-off before this ships (CLAUDE.md house rules).
    slug: "chess-ai",
    title: "Chess AI",
    description:
      "Play a chess engine built from scratch: minimax with alpha-beta pruning, running in a Web Worker, showing you every position it evaluates and every branch it skips.",
    tags: ["Chess", "AI", "Minimax", "Alpha-Beta", "Three.js", "Web Worker"],
    repo: "https://github.com/ErikkJs/goatsquadstudios",
    thumbnail: "/experience_thumbnails/chess-ai.png",
    status: "live",
  },
  {
    slug: "llm-token-counter",
    title: "LLM Token Counter & Cost Calculator",
    description: "Count tokens and see what they really cost across GPT, Claude, Gemini, Llama and DeepSeek: color-coded tokens plus the real bill in GPU memory, energy, water, CO₂, and dollars.",
    tags: ["Token Counter", "LLM", "Cost Calculator", "AI Cost", "Tokenization"],
    repo: "https://github.com/ErikkJs/goatsquadstudios",
    thumbnail: "/experience_thumbnails/llm-token-counter.png",
    status: "live",
  },
];

export function getExperience(slug: string): Experience | undefined {
  return experiences.find((exp) => exp.slug === slug);
}
